import { css } from 'emotion';

export const AccuracyButtonStyle = css({
  marginTop: '5px',
  marginRight: '5px',
});

export const NavigationHeaderStyle = {
  marginTop: '1.5em',
  marginLeft: '1.5em',
  marginBottom: '1.5em',
};

export const AccuracyButtonNewStyle = css({
  marginBottom: '1em',
  marginLeft: '1.5em',
  marginRight: '1em',
});

export const NegativeMarginAccuracyButtonNewStyle = css({
  marginLeft: '-1.5em',
  marginRight: '-1em',
});

export const AccuracyButtonWideStyle = css({
  marginBottom: '1em',
});

export const ToolTipWithMarginStyle = css({
  marginLeft: '1em',
  marginRight: '1em',
});

export const HeaderButtonsAlign = css({
  marginLeft: '1em',
});

export const CalculateButtonMargin = css({
  marginInlineStart: '1em',
});

export const DownloadButtonAlign = css({
  marginLeft: '1.5em',
  marginTop: '20px',
});

export const ReportFlashStyle = css({
  marginTop: '20px',
});

export const MaxHeightContainerStyle = css({
  maxHeight: '65vh', overflowY: 'scroll',
});

export const MaxHeightContainerWith80vh = css({
  maxHeight: '80vh', minHeight: '80vh', padding: '1px', overflowY: 'scroll',
});

export const ASINChartStyle = css({
  padding: '1px',
  marginTop: '1em',
});

export default {
  AccuracyButtonStyle,
  AccuracyButtonNewStyle,
  AccuracyButtonWideStyle,
  CalculateButtonMargin,
  HeaderButtonsAlign,
  DownloadButtonAlign,
  NavigationHeaderStyle,
  ReportFlashStyle,
};

//
export const ZERO_WIDTH_SPACE = '​';

export const TWO_ZERO_WIDTH_SPACE = '​​';


// WEBPACK FOOTER //
// ./src/styles/common_styles.jsx